{
    "DocumentViewer_AcceptButton": "Accepter",
    "DocumentViewer_CloseButton": "Fermer",
    "NAME": "DocumentViewer"
}